import PropTypes from 'prop-types';
import React, { Component } from 'react';
import AutoSearch from '../AutoSearch/AutoSearch';
import { Link, browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { SetQuery } from '../../actions';
import { gaEvent, xlt } from '../../utils/utils';
import styles from './Homepage.css';
import withStyles from '../../decorators/withStyles';


class Homepage extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchVal: props.q,
      componentKey: 0
    };
  }

  componentWillMount() {
    document.body.style.background = 'no-repeat url("/static/water_1920.jpg") #4b6186';
    document.body.style["background-size"] = 'cover';
  }

  componentWillUnmount() {
    document.body.style.background = '';
  }

  componentDidMount() {
    Transifex.live.onBeforeTranslatePage(() => {
      this.setState({componentKey: this.state.componentKey === 0 ? 1 : 0});
    });
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.dispatch(SetQuery(this.state.searchVal));
    browserHistory.push({pathname: "/search", query: {q: this.state.searchVal}, state: {...this.props, q: this.state.searchVal}});
  };

  render() {
    // const isBangla = this.props.routes[this.props.routes.length - 1].path === "/bangladesh" ? true : false;
    // const isCaribbean = this.props.routes[this.props.routes.length - 1].path === "/caribbean" ? true : false;
    const scope = this.props.routes[this.props.routes.length - 1].path.slice(1);
    const isBangla = scope === "bangladesh";
    const isCaribbean = scope != "";
    return (
      <div className="homepage-header">
        <div className="rising-seas">
          <nav className={"Header row nav " + (this.props.mobileMenuOpen ? "menu-open" : "")}>

            <div className="left-icon">
              <Link to={{pathname: "/about", state: {modal: true, homepage: true, modalTitle: "About this site", returnTo: location.pathname}}}>
                <button className="type-small nav-btn about-btn" data-navtarget="theaboutpage" data-paneltype="modal" data-gaq="Click:Nav:About" title="Learn about this map">
                  <span className="white icon info"></span>
                  <span className="small-screen">Learn about this map</span>
                </button>
              </Link>
            </div>

            <div className="">
              <h1 style={{"textAlign": "center"}}>
                <div className="logo-container">
                  <a className="logo-link--main" href="/">
                    <img className="logo-svg" src={require("../../public/logo-surging-seas-blue.svg")}/>
                  </a>
                  <a className="logo-link--sec" href="/">
                    <span>Risk Finder</span>
                  </a>
                </div>
              </h1>
            </div>

            <div className="right-icon">
              <a className="twitter" href="https://twitter.com/intent/tweet?text=See%20your%20local%20sea%20level%20and%20coastal%20flood%20risk%20on%20our%20Surging%20Seas%20Risk%20Finder%20tool&via=ClimateCentral&url=http://www.riskfinder.org" target="_blank"
              >
                <img className="nav-btn" src="/static/Twitter_Logo.svg" style={{width: 45, display: "inline"}}
                     onClick={() => {gaEvent('navlink', 'click', 'twitter');}}
                />
              </a>
              <a className="facebook" href="https://www.facebook.com/sharer.php?p%5Burl%5D=http://www.riskfinder.org/" target="_blank">
                <img className="nav-btn" src="/static/F_icon.svg"
                     onClick={() => {gaEvent('navlink', 'click', 'facebook');}}
                     style={{width: 25, marginLeft: 12, marginRight: 6, display: "inline"}}
                />
              </a>
            </div>
          </nav>
        </div>

        <div className="Homepage">
          <main>
            <section>
              <div className="title-block">
                <h1>Explore sea level and coastal flood risks</h1>
              </div>
                <AutoSearch
                  nav={false}
                  autofocus={true}
                  placeholder={xlt(isBangla ? "Enter a coastal place in Bangladesh" :
                                   isCaribbean ? `Enter a place in ${scope.replace(/-/g, " ").replace(/\b(?!and)\w/g,
                                   l => l.toUpperCase())}` : "Enter a U.S. coastal place")}
                  scope={scope}
                />
              <div className="search-link"><a href="http://sealevel.climatecentral.org/ssrf/help-page/" target="_blank"
                                              onClick={() => gaEvent('video-link', 'click', 'homepage')}>Video tutorial</a></div>
              <div className="search-error">
                  <a href="#" className="close">×</a>
                  <div className="error-text"></div>
                </div>
            </section>
          </main>
        </div>
      </div>
    );
  }

}

export default compose(
  withStyles(styles),
  connect((state) => state),
)(Homepage);
